import { render, staticRenderFns } from "./RedPacketNotification.vue?vue&type=template&id=53ed0654&scoped=true"
import script from "./RedPacketNotification.vue?vue&type=script&lang=js"
export * from "./RedPacketNotification.vue?vue&type=script&lang=js"
import style0 from "./RedPacketNotification.vue?vue&type=style&index=0&id=53ed0654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed0654",
  null
  
)

export default component.exports